import React, { useState } from 'react';
import PropTypes from 'prop-types';
import AttentionModal from '../../../../_common/Modal/AttentionModal/AttentionModal';
import classes from '../script.module.scss';
import Select from '../../../../_common/Form/Selects/Select/Select';

const cancelOptions = [
  'Change in Therapy',
  'Therapy Completion',
  'Change in Doctor',
  'Adverse Reaction',
  'Patient Deceased',
  'Duplicate Script',
  'Unaffordable',
  'Pharmacy Transfer',
  'Doctor Decision',
  'Transfer to Hub',
  'Patient Decision',
  'Patient Hospitalized',
  'Dose Change',
  'Manufacturer Free Drug Program',
  'Payor Restriction',
  'Unable to Reach Patient',
  'Unable to Reach Physician',
  'Other',
];

const CancelModal = ({
  isOpen, onClose, onSave, currentCancelReason,
}) => {
  const [cancelReason, setCancelReason] = useState(currentCancelReason);

  return (
    <AttentionModal
      onClose={onClose}
      isOpen={isOpen}
      onSave={() => onSave(cancelReason)}
      title={' You want to cancel the script. \n Are you sure?'}
      text={(
        <div className={classes.cancel_modal_select_wrapper}>
          <Select
            label="Reason for Cancelling"
            options={cancelOptions}
            onChange={(option) => setCancelReason(option)}
            currentOption={cancelReason}
            zIndex={31}
            hideClearButton
          />
        </div>
      )}
    />
  );
};

CancelModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  currentCancelReason: PropTypes.string.isRequired,
};

export default CancelModal;
